/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Session_Already_ExistsInputs */

const en_us2_workout_session_already_exists = /** @type {(inputs: Workout_Session_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This workout was already started on another device.`)
};

const pt_br2_workout_session_already_exists = /** @type {(inputs: Workout_Session_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este treino já foi iniciado em outro aparelho.`)
};

const es_419_workout_session_already_exists = /** @type {(inputs: Workout_Session_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este entrenamiento ya se inició en otro dispositivo.`)
};

const pt_pt2_workout_session_already_exists = /** @type {(inputs: Workout_Session_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este treino já foi iniciado noutro dispositivo.`)
};

const fr_fr2_workout_session_already_exists = /** @type {(inputs: Workout_Session_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette séance a déjà été commencée sur un autre appareil.`)
};

const de_de2_workout_session_already_exists = /** @type {(inputs: Workout_Session_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Training wurde bereits auf einem anderen Gerät gestartet.`)
};

const it_it2_workout_session_already_exists = /** @type {(inputs: Workout_Session_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo allenamento è già stato iniziato su un altro dispositivo.`)
};

/**
* | output |
* | --- |
* | "This workout was already started on another device." |
*
* @param {Workout_Session_Already_ExistsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_session_already_exists = /** @type {((inputs?: Workout_Session_Already_ExistsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Session_Already_ExistsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_session_already_exists(inputs)
	if (locale === "es-419") return es_419_workout_session_already_exists(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_session_already_exists(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_session_already_exists(inputs)
	if (locale === "de-DE") return de_de2_workout_session_already_exists(inputs)
	if (locale === "it-IT") return it_it2_workout_session_already_exists(inputs)
	return en_us2_workout_session_already_exists(inputs)
});
export { workout_session_already_exists as "workout.session_already_exists" }